'use client'

import { useState, useEffect } from 'react'
import { loadScript } from '@sidecar-utilities/browserUtils/loadScript'

export interface ScriptConfig {
  id: string
  src: string
  callback?: () => void
}

/**
 * Hook to inject any script based on a static config containing script
 * attributes. Tracks whether the script state is loaded using passed-in script
 * id.
 *
 * @param {string} id: Script id
 * @param {string} src: Script source
 * @param {function} callback: Callback function to execute after script is
 *   loaded
 * @returns {boolean} ScriptLoaded: indicates whether the script is loaded
 */
export const useInjectedScript = (scriptConfig: ScriptConfig) => {
  const [scriptLoaded, setScriptLoaded] = useState(false)

  useEffect(() => {
    loadScript({
      ...scriptConfig,
      callback: () => {
        if (scriptConfig.callback) {
          scriptConfig.callback()
        }
        setScriptLoaded(true)
      },
    })
  }, [scriptConfig])

  return scriptLoaded
}
